'use strict';

var FlightCabinFilterFactory = function FlightCabinFilterFactory(DataFilter) {
  function FlightCabinFilter() {
    this.sourceType = ['cabin', 'cabin-da', 'cabin-post-departure', 'class'];
    this.filterType = 'cabin';
  }
  FlightCabinFilter.constructor = FlightCabinFilter;
  FlightCabinFilter.prototype = Object.create(DataFilter.prototype);
  FlightCabinFilter.prototype.groupBy = 'cabinCode';
  return FlightCabinFilter;
};
FlightCabinFilterFactory.$inject = ['DataFilterFactory'];
module.exports = FlightCabinFilterFactory;